import { useLocalStorage } from '@mantine/hooks'

import { useMst } from '#state'

const LAST_SCRIPT_FORMAT_KEY = 'scripto-last-script-format'

export function useDefaultScriptFormat() {
  const { currentOrg } = useMst()
  const [lastScriptFormatId, setLastScriptFormatId] = useLocalStorage<string>({
    key: [LAST_SCRIPT_FORMAT_KEY, currentOrg?.id ?? ''].join(':'),
    getInitialValueInEffect: false,
  })

  if (!currentOrg) {
    throw new Error('Invariant: no workspace for default script format')
  }

  const { studioFormat, screenplayFormat } = currentOrg
  const defaultScriptFormat =
    lastScriptFormatId === studioFormat.id
      ? studioFormat
      : lastScriptFormatId === screenplayFormat.id
        ? screenplayFormat
        : studioFormat

  function setDefaultScriptFormat(formatId: string) {
    setLastScriptFormatId(formatId)
  }

  return { defaultScriptFormat, setDefaultScriptFormat }
}
